/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiError,
  DropAchievementListResponse,
  MyDropAchievementListResponse,
} from '../models/index';
import {
    ApiErrorFromJSON,
    ApiErrorToJSON,
    DropAchievementListResponseFromJSON,
    DropAchievementListResponseToJSON,
    MyDropAchievementListResponseFromJSON,
    MyDropAchievementListResponseToJSON,
} from '../models/index';

export interface GetDropsSlugAchievementsRequest {
    slug: string;
}

export interface GetDropsSlugMeAchievementsRequest {
    slug: string;
}

/**
 * DropAchievementsApi - interface
 * 
 * @export
 * @interface DropAchievementsApiInterface
 */
export interface DropAchievementsApiInterface {
    /**
     * Returns all active achievement definitions for the Drop. Public endpoint.
     * @summary List active achievements for a Drop
     * @param {string} slug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DropAchievementsApiInterface
     */
    getDropsSlugAchievementsRaw(requestParameters: GetDropsSlugAchievementsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DropAchievementListResponse>>;

    /**
     * Returns all active achievement definitions for the Drop. Public endpoint.
     * List active achievements for a Drop
     */
    getDropsSlugAchievements(requestParameters: GetDropsSlugAchievementsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DropAchievementListResponse>;

    /**
     * Returns all active achievements — standalone HubAchievements plus checkpoint-authored badges, merged — with unlock status and progress for the authenticated user.
     * @summary Get my achievement progress for a hub
     * @param {string} slug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DropAchievementsApiInterface
     */
    getDropsSlugMeAchievementsRaw(requestParameters: GetDropsSlugMeAchievementsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MyDropAchievementListResponse>>;

    /**
     * Returns all active achievements — standalone HubAchievements plus checkpoint-authored badges, merged — with unlock status and progress for the authenticated user.
     * Get my achievement progress for a hub
     */
    getDropsSlugMeAchievements(requestParameters: GetDropsSlugMeAchievementsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MyDropAchievementListResponse>;

}

/**
 * 
 */
export class DropAchievementsApi extends runtime.BaseAPI implements DropAchievementsApiInterface {

    /**
     * Returns all active achievement definitions for the Drop. Public endpoint.
     * List active achievements for a Drop
     */
    async getDropsSlugAchievementsRaw(requestParameters: GetDropsSlugAchievementsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DropAchievementListResponse>> {
        if (requestParameters['slug'] == null) {
            throw new runtime.RequiredError(
                'slug',
                'Required parameter "slug" was null or undefined when calling getDropsSlugAchievements().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/drops/{slug}/achievements`;
        urlPath = urlPath.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters['slug'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DropAchievementListResponseFromJSON(jsonValue));
    }

    /**
     * Returns all active achievement definitions for the Drop. Public endpoint.
     * List active achievements for a Drop
     */
    async getDropsSlugAchievements(requestParameters: GetDropsSlugAchievementsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DropAchievementListResponse> {
        const response = await this.getDropsSlugAchievementsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns all active achievements — standalone HubAchievements plus checkpoint-authored badges, merged — with unlock status and progress for the authenticated user.
     * Get my achievement progress for a hub
     */
    async getDropsSlugMeAchievementsRaw(requestParameters: GetDropsSlugMeAchievementsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MyDropAchievementListResponse>> {
        if (requestParameters['slug'] == null) {
            throw new runtime.RequiredError(
                'slug',
                'Required parameter "slug" was null or undefined when calling getDropsSlugMeAchievements().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/drops/{slug}/me/achievements`;
        urlPath = urlPath.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters['slug'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MyDropAchievementListResponseFromJSON(jsonValue));
    }

    /**
     * Returns all active achievements — standalone HubAchievements plus checkpoint-authored badges, merged — with unlock status and progress for the authenticated user.
     * Get my achievement progress for a hub
     */
    async getDropsSlugMeAchievements(requestParameters: GetDropsSlugMeAchievementsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MyDropAchievementListResponse> {
        const response = await this.getDropsSlugMeAchievementsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
